import {
  addDoc,
  CollectionReference,
  DocumentData,
  DocumentReference,
  WithFieldValue,
} from "firebase/firestore";
import { useCallback, useState } from "react";

export const useAddDoc = <D extends DocumentData = DocumentData>(
  ref: CollectionReference<D> | undefined
): [
  (data: WithFieldValue<D>) => Promise<DocumentReference | false>,
  boolean,
  Error | undefined
] => {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);
  const add = useCallback(
    (data: WithFieldValue<D>): Promise<DocumentReference | false> => {
      if (!ref) {
        throw new Error("Must specify collection to create document in");
      }
      if (saving) {
        throw new Error("Already saving");
      }
      setSaving(true);
      setError(undefined);
      return addDoc(ref, data)
        .then((docDef) => {
          setSaving(false);
          return docDef;
        })
        .catch((err: Error) => {
          setSaving(false);
          setError(err);
          return false;
        });
    },
    [ref, saving, setError, setSaving]
  );

  return [add, saving, error];
};
